import {
	Component, forwardRef, Inject, ViewEncapsulation
}                                    from '@angular/core';
import { DashboardPanelComponentBase }   from '@cs/components/shared';
import { DataDescribed, SelectionTargetResult } from '@cs/core';
import { hasPropertyOf }                 from '@cs/core/utils';
import { DashboardEventHub }             from '../../dashboard-event-hub.service';
import { DashboardPanelOptions }         from '../../models/dashboard-panel-options';
import {
	DashboardTabControlData,
	TabControlTab,
	TabControlLayout,
	TabControlMetaInfo
}                                        from './dashboard-tab-control-data';

@Component({
	selector:      'cs-dashboard-tab-control',
	templateUrl:   './dashboard-tab-control.component.html',
	styleUrls:     ['./dashboard-tab-control.component.scss'],
	encapsulation: ViewEncapsulation.None,
	standalone:    false
})
export class DashboardTabControlComponent extends DashboardPanelComponentBase<any> {

	name: string;
	tabs: TabControlTab[] = [];
	activeTab: string;
	align: 'left' | 'center' | 'right' = 'left';

	private described: DataDescribed<TabControlTab[], TabControlLayout, TabControlMetaInfo>;

	constructor(@Inject(forwardRef(() => DashboardEventHub)) private dashboardEventHub: DashboardEventHub,
							@Inject(DashboardPanelOptions) private dashboardOptions: DashboardPanelOptions) {
		super();
	}

	dataChanged(value: any): void {
		this.parseData(value);
	}

	update(data: any): void {
		this.data = data;
	}

	switchTab(tab: TabControlTab): void {
		if (tab.key === this.activeTab) {
			return;
		}

		const result: SelectionTargetResult = {
			panelName:           this.name,
			dashboardInstanceId: '',
			selectionAction:     'CurrentWindow',
			selectionObject:     {SubCategory: tab.key},
			selectionContext:     {},
			selectionRoute:      null
		};

		this.dashboardEventHub.isDashboardEntryIsClicked.next(result);
	}

	private parseData(value: any): void {
		if (!value) return;

		if (hasPropertyOf(value, 'dataAnnotation')) {
			// DataDescribed format
			this.described = new DataDescribed<TabControlTab[], TabControlLayout, TabControlMetaInfo>(value);
			this.tabs      = Array.isArray(this.described.data) ? this.described.data : [];
			this.activeTab = this.described.dataSetMetaInfo?.activeTab ?? '';
			this.align     = this.described.layout?.align ?? 'left';
		} else {
			// Legacy format
			const legacy   = value as DashboardTabControlData;
			this.tabs      = legacy.tabs ?? [];
			this.activeTab = legacy.activeTab ?? '';
			this.align     = 'left';
		}
	}
}
